import { CompanySizeOption } from './CompanySizeOption';
import { CompanySizeNumber } from './CompanySizeNumber';
import { CompanySizeScreamingSnake } from './CompanySizeScreamingSnake';
export const CompanySizeAttributes = {
  [CompanySizeOption.One]: {
    companySizeNumber: CompanySizeNumber.One,
    companySizeLabel: '1',
    companySizeRange: {
      min: 1,
      max: 1
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.ONE
  },
  [CompanySizeOption.TwoToFive]: {
    companySizeNumber: CompanySizeNumber.TwoToFive,
    companySizeLabel: '2 to 5',
    companySizeRange: {
      min: 2,
      max: 5
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.TwoToFive
  },
  [CompanySizeOption.SixToTen]: {
    companySizeNumber: CompanySizeNumber.SixToTen,
    companySizeLabel: '6 to 10',
    companySizeRange: {
      min: 6,
      max: 10
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.SixToTen
  },
  [CompanySizeOption.ElevenToTwentyFive]: {
    companySizeNumber: CompanySizeNumber.ElevenToTwentyFive,
    companySizeLabel: '11 to 25',
    companySizeRange: {
      min: 11,
      max: 25
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.ElevenToTwentyFive
  },
  [CompanySizeOption.TwentySixToFifty]: {
    companySizeNumber: CompanySizeNumber.TwentySixToFifty,
    companySizeLabel: '26 to 50',
    companySizeRange: {
      min: 26,
      max: 50
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.TwentySixToFifty
  },
  [CompanySizeOption.FiftyOneToOneHundred]: {
    companySizeNumber: CompanySizeNumber.FiftyOneToOneHundred,
    companySizeLabel: '51 to 100',
    companySizeRange: {
      min: 51,
      max: 100
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.FiftyOneToOneHundred
  },
  [CompanySizeOption.OneHundredOneToTwoHundred]: {
    companySizeNumber: CompanySizeNumber.OneHundredOneToTwoHundred,
    companySizeLabel: '101 to 200',
    companySizeRange: {
      min: 101,
      max: 200
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.OneHundredAndOneToTwoHundred
  },
  [CompanySizeOption.TwoHundredOneToFiveHundred]: {
    companySizeNumber: CompanySizeNumber.TwoHundredOneToFiveHundred,
    companySizeLabel: '201 to 500',
    companySizeRange: {
      min: 201,
      max: 500
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.TwoHundredAndOneToFiveHundred
  },
  [CompanySizeOption.FiveHundredOneOrMore]: {
    companySizeNumber: CompanySizeNumber.FiveHundredOneOrMore,
    companySizeLabel: '501 or more',
    companySizeRange: {
      min: 501,
      max: Infinity
    },
    companySizeScreamingSnake: CompanySizeScreamingSnake.FiveHundredAndOneOrMore
  }
};